export default "__VITE_ASSET__CPU7KhqK__"